import React from "react";
import PropTypes from "prop-types";
import { recordIdType } from "data/util/typedefs";
import Dispatcher from "Dispatcher";
import PrintActions from "lib/dataentry/lib/print/PrintActions";

function PrintButton(props) {
    const {
        entityKey,
        recordId: id,
    } = props;

    const handleClick = () =>
        Dispatcher.dispatch({
            type: PrintActions.LAUNCH_DIALOG,
            entityKey,
            id,
        });

    return <button
        className="btn btn-secondary btn-print"
        onClick={handleClick}
    >
        <i className="glyphicon glyphicon-print"/> Print...
    </button>;
}

PrintButton.propTypes = {
    entityKey: PropTypes.string.isRequired,
    recordId: recordIdType.isRequired,
};

export default PrintButton;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/print/PrintButton.js